import React from 'react';
import { TaxonomyUtil, useApi, CondensedMedium } from '@axiom/ui';
import type { Candidate, CandidateRedux } from '@axiom/validation';

import { TaxonomyApi } from '../../api/taxonomy-api';

export type TalentPracticeAreaProps = {
  candidate: CandidateRedux | Candidate;
  name: string;
};

export const TalentProfileDetailPracticeArea = ({
  candidate,
  name,
}: TalentPracticeAreaProps) => {
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());
  return (
    <CondensedMedium name={name}>
      {TaxonomyUtil.formatPracticeAreaFocusAreaForDisplay(
        taxonomy,
        candidate.primaryPracticeArea,
        candidate.primaryFocusArea
      ) ?? '--'}
    </CondensedMedium>
  );
};
